import Swiper, {Navigation, Scrollbar} from 'swiper'

export default {
  init() {
    Swiper.use([Navigation, Scrollbar]);

    this.mobileNav()
    this.ctaSlider()
    this.postsSlider()

  },
  mobileNav() {
    $(document).on('click', '.v2-site-header__burger', function(e) {
      e.preventDefault()
      const $body = $('body')

      $body.toggleClass('mobile-nav-open')
      if ($body.hasClass('mobile-nav-open')) {
        $(this).attr('aria-expanded', true)
        $('#v2-mobile-nav').find('a').first().focus()
      } else {
        $(this).attr('aria-expanded', false)
      }
    })
  },
  ctaSlider() {
    const $ctaSliders = $('.cta-slider .swiper')
    if (!$ctaSliders.length) {
      return
    }

    $ctaSliders.each(function () {
      new Swiper($(this).get(0), {
        slidesPerView: 2.25,
        spaceBetween: 20,
        loop: false,
        speed: 400,
        navigation: {
          nextEl: $(this).find('.swiper-button-next').get(0),
          prevEl: $(this).find('.swiper-button-prev').get(0),
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          dragSize: 200,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
      })
    })
  },
  postsSlider() {
    const $postsSliders = $('.v2-posts-slider .swiper')
    if (!$postsSliders.length) {
      return
    }

    $postsSliders.each(function () {
      new Swiper($(this).get(0), {
        slidesPerView: 1.5,
        spaceBetween: 40,
        loop: false,
        speed: 400,
        navigation: {
          nextEl: $(this).find('.swiper-button-next').get(0),
          prevEl: $(this).find('.swiper-button-prev').get(0),
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          dragSize: 200,
        },
        breakpoints: {
          420: {
            slidesPerView: 2.2,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 60,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 100,
          },
        },
      })
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/v2/template-home-v2.js